import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import MyDataIcon from './components/images/my-data-icon';
import PersonalDataForm from './components/personal-data-form';
import AddressForm from './components/address-form';
import Questions from './components/questions';
import AsyncLoading from './components/async-loading';
import InvalidAuth from './components/invalid-auth';
import SuccessPage from './components/success-page';
import FailurePage from './components/failure-page';
import ErrorPage from './components/error';
import * as actions from './actions/app-actions';
// import STEP from './constants/app-step';
import WorkflowStep  from './constants/workflow-steps';
import RequestType from './constants/request-types';
import AppForm from './constants/app-forms';
import MessageForm from './components/message-form';
import ThirdPartyForm from './components/third-party-form';

class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showInitialForm: true,
            formData: {},
            formToShowNow: AppForm.PersonalData,
            requestType: RequestType.Disclose,
            isThirdParty: false
        };
        this.renderForm = this.renderForm.bind(this);
        this.handleNextStep = this.handleNextStep.bind(this);
        this.getModeInfo = this.getModeInfo.bind(this);

        const modeInfo = this.getModeInfo();
        this.state.requestType = modeInfo.requestType;
        this.state.isThirdParty = modeInfo.isThirdParty;
        //form data request type doesn't differentiate between third party vs. not and also just wants a string
        this.state.formData.requestType = modeInfo.serverRequestType;
        this.props.requestSSN = !modeInfo.isThirdParty && !(modeInfo.requestType === RequestType.Appeal);

        

    }


    getModeInfo() {
        try {
            const urlParts = window.location.href.split('/');
            let isThirdParty = false;
            const urlRequestType = urlParts[4].toLowerCase();
            if(urlParts.length > 5) {
                const behalf = urlParts[5].toLowerCase();
                isThirdParty = behalf === 'behalf';
            }
            this.props.isThirdParty = isThirdParty;
            let requestType = RequestType.Disclose;


            switch(urlRequestType) {
                case 'disclose':
                    requestType = (isThirdParty ? RequestType.DiscloseBehalf : RequestType.Disclose);
                    break;
                case 'delete':
                    requestType = (isThirdParty ? RequestType.DeleteBehalf : RequestType.Delete);
                    break;
                case 'correct':
                    requestType = (isThirdParty ? RequestType.CorrectBehalf : RequestType.Correct);
                    break;
                case 'appeal':
                    requestType = (isThirdParty ? RequestType.AppealBehalf : RequestType.Appeal);
                    break;
            }
            return { requestType:requestType, isThirdParty: isThirdParty, serverRequestType: urlRequestType };
            
        } catch(ex) {
            //return {requestType:'',isThirdParty:false};
            throw ex; 
        }
    }

   

    renderForm() {
        switch(this.state.formToShowNow) {
            case AppForm.PersonalData: return <PersonalDataForm handleNextStep={this.handleNextStep} requestSSN={this.props.requestSSN} isThirdParty={this.props.isThirdParty} />;
            case AppForm.Address: return <AddressForm handleNextStep={this.handleNextStep} requestType={this.state.requestType} isThirdParty={this.props.isThirdParty} />
            case AppForm.Questions: return <Questions handleNextStep={this.handleNextStep} />
            case AppForm.Message: return <MessageForm handleNextStep={this.handleNextStep} requestType={this.state.requestType} />
            case AppForm.ThirdParty: return <ThirdPartyForm handleNextStep={this.handleNextStep} />
            case AppForm.Success: return <SuccessPage requestType={this.state.requestType} isThirdParty={this.state.isThirdParty} />
            case AppForm.KBAFailure: return <InvalidAuth requestType={this.state.requestType} />
            case AppForm.KBALimitReached: return <FailurePage />
            case AppForm.FileSizeLimitExceeded: return <ErrorPage showFileUploadError={true} />
            case AppForm.Error: return <ErrorPage />
            //default:  return <ErrorPage />
            default: return <></>
        }
    }
    

    componentDidUpdate(prevProps) {
        if (this.props.fullFailure && !prevProps.fullFailure) {
            this.setState({ formToShowNow: AppForm.Error });
        }

        if(this.props.fileUploadFailure && !prevProps.fileUploadFailure) {
            this.setState({ formToShowNow: AppForm.FileSizeLimitExceeded});
        }
    
        if (this.props.currentStep !== prevProps.currentStep) {
            if (this.props.currentStep === WorkflowStep.Questions && this.state.formToShowNow === AppForm.Questions) {
                if (this.props.dataSuccess) {
                    this.setState({ formToShowNow: AppForm.Success });
                } 
                if (this.props.dataFailure) {
                    const formToShow = this.props.fullFailure ? AppForm.KBALimitReached : AppForm.KBAFailure;
                    this.setState({ formToShowNow: formToShow });
                }
            }
    
            if (this.props.currentStep === WorkflowStep.AuthFailure) {
                this.setState({ formToShowNow: AppForm.KBAFailure });
            }
    
            if (this.props.currentStep === WorkflowStep.PersonalData && this.props.fullFailure) {
                this.setState({ formToShowNow: AppForm.KBALimitReached });
            }
    
            if (this.props.currentStep === WorkflowStep.UnhandledError || this.props.fullFailure) {
                this.setState({ formToShowNow: AppForm.Error });
            }
        }
    }

    render() {
        const { isPosting } = this.props;
    
        const asyncLoadingMessageUnvalidated = this.state.isThirdParty || this.state.requestType === RequestType.Appeal;
    
        return (
            <div className='app-container'>
                <div className='app-main'>
                    {isPosting ? <AsyncLoading showUnvalidated={asyncLoadingMessageUnvalidated} /> : this.renderForm()}
                </div>
                <div className='app-media'>
                    <MyDataIcon />
                </div>
            </div>
        );
    }

    handleNextStep(caller, callersFormData) {
        if(!caller) return;

        if(this.state.fileUploadFailure) {
            this.setState({ formToShowNow: AppForm.FileSizeLimitExceeded},() => { this.renderForm(); });
            return;
        }

        switch(caller) {
            case AppForm.PersonalData:
                this.setState({ formToShowNow: AppForm.Address , formData: {...this.state.formData, ...callersFormData}},() => { this.renderForm(); });
                break;
            case AppForm.Address:
                switch(this.state.requestType) {
                    case RequestType.Disclose:
                    case RequestType.Delete:
                        this.setState({formToShowNow: AppForm.Questions, formData: {...this.state.formData, ...callersFormData}},() => { this.props.postIntakeForm(this.state.formData); });
                        break;
                    case RequestType.Appeal:
                    case RequestType.CorrectBehalf:
                    case RequestType.AppealBehalf:
                    case RequestType.Correct:
                        this.setState({formToShowNow: AppForm.Message, formData: {...this.state.formData, ...callersFormData}},() => { this.renderForm(); });
                        break;
                    case RequestType.DiscloseBehalf:
                    case RequestType.DeleteBehalf:
                        this.setState({ formToShowNow: AppForm.ThirdParty, formData: {...this.state.formData, ...callersFormData}}, () => { this.renderForm();});
                        //set as error page until all flows are wired
                        this.props.dataFailure = true;
                        break;
                }
                break;
            case AppForm.Questions:
                if(this.props.dataSuccess) {
                    this.setState({ formToShowNow: AppForm.Success});
                }
                break;
            case AppForm.Message:
                switch(this.state.requestType) {
                    case RequestType.Correct:
                        this.setState({formToShowNow: AppForm.Questions, formData: {...this.state.formData, ...callersFormData}},() => { this.props.postIntakeForm(this.state.formData); });
                        break;
                    case RequestType.Appeal:
                        this.setState({ formToShowNow: AppForm.Success, formData: {...this.state.formData, ...callersFormData }}, () => { this.props.postUnvalidatedRequest(this.state.formData); });
                        break;
                    case RequestType.CorrectBehalf:
                    case RequestType.AppealBehalf:
                        this.setState({ formToShowNow: AppForm.ThirdParty, formData: {...this.state.formData, ...callersFormData}}, () => { this.renderForm();});
                        break;
                }
                break;
            case AppForm.ThirdParty:
                //always success
                this.setState({ formToShowNow: AppForm.Success, formData: { ...this.state.formData, ...callersFormData}}, () => { this.props.postUnvalidatedRequest(this.state.formData);});
                break;
        }
    }
}

const mapStateToProps = state => {
    return {
        isPosting: state.app.isPosting,
        dataSuccess: state.app.dataSuccess,
        dataFailure: state.app.dataFailure,
        fileUploadFailure: state.app.fileUploadFailure,
        fullFailure: state.app.fullFailure,
        currentStep: state.app.currentStep,
        requestType: state.app.requestType,
        timeOutFailure: state.app.timeOutFailure
    };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators({ ...actions }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(App);